import CategoriesTemp from 'component/organism/categories/CategoriesTemp';
import AddCategory from 'component/organism/categories/factory/addCategory/AddCategory';
import ViewCategories from 'component/organism/categories/factory/viewCategories/ViewCategories';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const Categories = () => {
  const { id } = useParams();
  const [isShowCategories, setIsShowCategories] = useState(false);
  const [isAddCategory, setIsAddCategory] = useState(false);
  const [isRefetch, setIsRefetch] = useState(null);
  const [item, setIsItem] = useState(null);

  const handleClose = () => {
    setIsAddCategory(false);
    setIsShowCategories(false);
    setIsItem(null);
  };
  const handleEdit = (item) => {
    setIsItem(item);
    setIsShowCategories(false);
    setIsAddCategory(true);
  };
  return (
    <>
      <SettingsHeader
        title='Categories'
        rightButtons={[
          {
            label: 'View Categories',
            opicBackground: true,
            func: () => setIsShowCategories(true),
          },
        ]}
      />
      <CategoriesTemp isRefetch={isRefetch} />
      <ViewCategories
        isOpen={isShowCategories}
        onClose={handleClose}
        id={id}
        isRefetch={isRefetch}
        handleEdit={handleEdit}
        setIsAddCategory={setIsAddCategory}
      />
      <AddCategory
        isOpen={isAddCategory}
        onClose={handleClose}
        id={id}
        setIsRefetch={setIsRefetch}
        item={item}
        setIsShowCategories={setIsShowCategories}
        isRefetch={isRefetch}
      />
    </>
  );
};

export default Categories;
